import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EvLogoLoaderComponent } from 'src/app/shared-components/ev-logo-loader/ev-logo-loader.component';

@Component({
    selector: 'redirect-page',
    imports: [EvLogoLoaderComponent],
    templateUrl: './redirect-page.component.html',
    styleUrl: './redirect-page.component.scss'
})
export class RedirectPageComponent {
  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
  
  }
}
